export enum MlCacheType {
    SEGMENTATION_TRAINING = 'SegmentationTraining',
    SEGMENTATION = 'Segmentation',
    SEGMENTATIONS_WITHOUT_MODEL = 'SegmentationsWithoutModels',
    MODELS_WITH_SEGMENTATIONS = 'ModelsWithSegmentations',
}
